import { useApi } from "hooks"
import { useSession } from "hooks";
import { useQuery } from '@tanstack/react-query'


const useGetPurchased = ({ contentType }) => {
  const { isLoggedIn } = useSession();

  const { apiFetch } = useApi();

  const url = `/me/contents/purchased?contentType=${contentType}`

  const getContent = () => {
    return apiFetch({ url })
      .then(res => res.data)
  }

  const options = {
    staleTime: 60000 * 30, // 30 min
    placeholderData: null,
    enabled: isLoggedIn
  }

  return useQuery(
    ['purchases', contentType],
    getContent,
    options
  )
}

export default useGetPurchased;
